import { createScreenshotEvent } from "@/lib/events";
import { showSideBar } from "@/state/config";
import clsx from "clsx";
import type { FunctionalComponent } from "preact";
import { version } from "../../scripts/version" with { type: "macro" };
import Logo from "./Logo";
import Config from "./config/Config";

const Sidebar: FunctionalComponent = () => {
    const closeSidebar = () => {
        showSideBar.value = false;
    };

    const screenshot = () => {
        window.dispatchEvent(createScreenshotEvent());
    };

    return (
        <>
            <div
                class={clsx(
                    "z-50 flex h-full border-gray-700 bg-gray-900 text-white opacity-90 transition-transform duration-300",
                    "items-center px-10 py-4",
                    "fixed top-0 w-64 flex-col border-r",
                    {
                        "translate-x-0": showSideBar.value,
                        "-translate-x-96": !showSideBar.value,
                    },
                )}
            >
                <Logo word1="Stream" word2="Cast" />

                <hr class="mt-3 hidden w-2/5 border-gray-400 sm:block" />

                <Config class="mt-2 flex flex-col items-center justify-between font-semibold" />

                <button
                    type="button"
                    class="mt-6 cursor-pointer rounded bg-blue-400 px-3 py-2 font-semibold text-white text-xs shadow-sm hover:bg-blue-300"
                    onClick={screenshot}
                >
                    (<span class="font-extrabold text-sm">S</span>)creenshot
                </button>

                <button
                    type="button"
                    class="mt-6 cursor-pointer rounded bg-red-600 px-3 py-2 font-semibold text-white text-xs shadow-sm hover:bg-red-400"
                    onClick={closeSidebar}
                >
                    (<span class="font-extrabold text-sm">C</span>)lose
                </button>

                <div class="absolute bottom-2 text-xs tracking-tighter">v{version()}</div>
            </div>
        </>
    );
};

export default Sidebar;
